import { Image } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import PurchaseItemInputs from "../../../component/inventory/purchase-item/PurchaseItemInputs";

export default function PurchaseItemEdit() {
  const navigate = useNavigate();
  const [purchaseItems, setPurchaseItems] = useState([
    {
      id: crypto.randomUUID(),
      itemName: "",
      itemQty: "",
      itemUnit: "",
      unitPrice: "",
      totalAmount: "",
      carriageInwards: "",
      purchaseDate: "",
      supplier: "",
    },
  ]);

  function onHandleAddPurchaseItemInput() {
    setPurchaseItems((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        itemName: "",
        itemQty: "",
        itemUnit: "",
        unitPrice: "",
        totalAmount: "",
        carriageInwards: "",
        purchaseDate: "",

        supplier: "",
      },
    ]);
  }

  function onHandleRemovePurchaseItemInput(ingId) {
    setPurchaseItems((prev) => prev.filter((item) => item.id !== ingId));
  }

  function onHandleCancel() {
    navigate("/inventory/purchase-item/reports");
  }

  function onHandleSave() {
    const purchaseItemWithoutId = purchaseItems.map(({ id, ...rest }) => rest);
    console.log("___ingredientsWithoutId___", purchaseItemWithoutId);
  }

  return (
    <div className="flex flex-col">
      {/* <CustomLoader /> */}
      <Header
        title={`McDonalds Food Chains`}
        menu={constants.MENU.INVENTORY}
        currentMenuKey={"T_7_S_7_L_2"}
      />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.MENU.INVENTORY}
        />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent
              title={"Edit Purchase item"}
              listRoute="/inventory/purchase-item/reports"
            />
          </div>

          <div className="w-full h-auto min-h-[50vh] bg-white rounded-[12px] pl-[37px] pt-[50px]">
            {/* item header */}
            <div className="flex items-center space-x-3 font-p_medium text-xs leading-[13px] text-black mb-[10px] mr-[37.67px]">
              <p className="w-[185px]">Item name</p>
              <p className="w-[82px]">Item Qty</p>
              <p className="w-[90px]">Item Unit</p>
              <p className="w-[83px]">Unit price</p>
              <p className="w-[87px]">Total Amount</p>
              <p className="w-[110px]">Carriage Inwards</p>
              <p className="w-[126px]">Purchase Date</p>
              <p className="w-[152px]">Supplier</p>

            </div>
            {purchaseItems.map((ing, idx) => (
              <div
                className="w-full flex items-center gap-x-[15px] mb-3"
                key={ing.id}
              >
                <PurchaseItemInputs
                  records={{ ingId: ing.id, purchaseItems, setPurchaseItems }}
                />

                {/* {idx === purchaseItems.length - 1 ? (
                  <button className="" onClick={onHandleAddPurchaseItemInput}>
                    <Image src="/images/icons/add_one.svg" preview={false} />
                  </button>
                ) : (
                  <button
                    className=""
                    onClick={() => onHandleRemovePurchaseItemInput(ing.id)}
                  >
                    <Image src="/images/icons/remove_one.svg" preview={false} />
                  </button>
                )} */}
              </div>
            ))}

            <div className="flex items-center space-x-3 pt-[76px] pb-5">
              <button
                onClick={onHandleCancel}
                className="font-bold w-[100px] h-[42px] bg-[#FCBD10] text-black rounded-[5px] text-base leading-[16px]"
              >
                Cancel
              </button>
              <button
                onClick={onHandleSave}
                className="font-bold w-[100px] h-[42px] bg-black text-white rounded-[5px] text-base leading-[16px]"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
